function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 490,
  height: 144,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F8FA",
  fillRule: "evenodd",
  d: "M410.641 3c7.554 0 13.678 5.067 13.678 11.317s-6.124 11.318-13.678 11.318h-78.16c7.554 0 13.678 5.067 13.678 11.317s-6.124 11.318-13.678 11.318h42.988c7.554 0 13.678 5.066 13.678 11.317 0 6.25-6.124 11.317-13.678 11.317h-19.88c-9.525 0-17.246 5.067-17.246 11.318q0 6.251 11.724 11.317c7.554 0 13.678 5.067 13.678 11.318s-6.124 11.317-13.678 11.317H187.884c-7.554 0-13.678-5.067-13.678-11.317s6.124-11.318 13.678-11.318h-76.206C104.124 93.54 98 88.472 98 82.222s6.124-11.318 13.678-11.318h78.16c7.555 0 13.678-5.067 13.678-11.317s-6.123-11.317-13.678-11.317h-48.85c-7.554 0-13.678-5.067-13.678-11.318s6.124-11.317 13.678-11.317h78.16c-7.554 0-13.678-5.067-13.678-11.318S211.594 3 219.148 3zm0 45.27c7.554 0 13.678 5.066 13.678 11.317 0 6.25-6.124 11.317-13.678 11.317s-13.678-5.067-13.678-11.317 6.124-11.317 13.678-11.317",
  clipRule: "evenodd",
  style: {
    fill: "#f7f8fa",
    fill: "color(display-p3 .9702 .9735 .98)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#476CFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.1,
  strokeWidth: 7.5,
  d: "M459.143 26.826h-14.455m25.637-22.834h-30.368zm12.377 0h-3.928zM166.809 139.999h-17.637m7.55-25.811H119.67zm-49.616 0H98z",
  style: {
    stroke: "#476cff",
    stroke: "color(display-p3 .2784 .4235 1)",
    strokeOpacity: 0.1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#476CFF",
  fillOpacity: 0.24,
  d: "m303.095 78.847 12.849 12.846-4.245 4.245-12.846-12.849a26.88 26.88 0 0 1-16.851 5.907c-14.904 0-27-12.096-27-27s12.096-27 27-27 27 12.096 27 27a26.88 26.88 0 0 1-5.907 16.851m-6.018-2.226a20.93 20.93 0 0 0 5.925-14.625c0-11.604-9.399-21-21-21-11.604 0-21 9.396-21 21 0 11.601 9.396 21 21 21a20.93 20.93 0 0 0 14.625-5.925zm-11.541-26.097a6 6 0 0 0-3.258 7.255 6 6 0 0 0 6.805 4.116 6 6 0 0 0 4.391-3.433 12 12 0 1 1-7.938-7.938",
  style: {
    fill: "#476cff",
    fill: "color(display-p3 .2784 .4235 1)",
    fillOpacity: 0.24
  }
}));
export { SvgSearch as ReactComponent };
export default __webpack_public_path__ + "149c49b14fc925e39475f3ef6f4b6adc.svg";